var authorization = require('./services/authorization');
var router = require('./services/router');
var helpers = require('./services/helpers');

var preloader = require('./components/preloader');
var messages = require('./components/messages');

var Login = function () {
    var self = this;

    this.email = ko.observable('');
    this.password = ko.observable('');

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.is_request_sent = ko.observable(false);

    this.getData = function () {
        return {
            email: self.email(),
            password: self.password(),
            'g-recaptcha-response': document.querySelector('[name=g-recaptcha-response]').value,
        }
    };

    this.isValid = function (no_validate) {
        var messages_list = [];
        var target_focus;

        self.email(self.email().trim());
        self.password(self.password().trim());

        if (no_validate && no_validate.indexOf('password') == -1 && self.password().length == 0) {
            target_focus = 'password';
            messages_list.push('Please, fill "password" field');
        }
        if (self.email().length == 0) {
            target_focus = 'email';
            messages_list.push('Please, fill "email" field');
        } else if (!helpers.validateEmail(self.email())) {
            target_focus = 'email';
            messages_list.push('Wrong "email" field format');
        }

        if (messages_list.length == 0) return true;

        messages.addItems(messages_list.reverse(), {clear: true});
        helpers.focusSequence(messages_list.join( ), function () {
            self.focused(target_focus);
        });

        return false;
    };

    this.clean = function (options) {
        if (!options || options.email) self.email('');
        if (!options || options.password) self.password('');
    };

    this.authorizeUser = function () {
        messages.removeAllItems();

        if(!self.isValid()) {
            self.clean({email: false, password: true});
            return;
        }

        preloader.show('login');
        authorization.login(function (status, message) {
            preloader.hide('login');
            if (!status) {
                self.clean({login: false, password: true});
                helpers.focusSequence(message, function () {
                    self.focused('email');
                });
                return;
            }

            self.clean();
            messages.removeAllItems();
            var viewModel = require('./viewModel');
            viewModel.init();
            router.goTo(viewModel.your_addresses.missing_address() ? 'your-addresses' :'default');
        }, self.getData());
    };

    this.unAuthorizeUser = function () {
        authorization.logout(function () {
            var viewModel = require('./viewModel');
            router.goTo('login');
            viewModel.clean();
        })
    };
    
    this.resetPassword = function () {
        if (!self.isValid(['password'])) return;

        preloader.show('reset-password');
        authorization.resetPassword(function (status, message) {
            preloader.hide('reset-password');
            if (!status) {
                helpers.focusSequence(message, function () {
                    self.focused('email');
                });
                return;
            }

            self.is_request_sent(true);
            self.focused('sent_request_message');
        }, self.getData())
    };

    this.onShow = function () {
        self.focused('title');
    }
};

module.exports = Login;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/LoginPage.js
// module id = 25
// module chunks = 0